// src/pages/VideoResources.js
import React, { useState } from "react";

const TOPIC_MAP = [
  // Quant
  { topic: "Probability",         category: "Quant",     link: "https://www.youtube.com/results?search_query=probability+for+bank+exams+playlist" },
  { topic: "Pipes & Cisterns",    category: "Quant",     link: "https://www.youtube.com/results?search_query=pipes+and+cisterns+for+bank+exams+playlist" },
  { topic: "Percentage",          category: "Quant",     link: "https://www.youtube.com/results?search_query=percentage+for+bank+exams+playlist" },
  { topic: "Profit & Loss",       category: "Quant",     link: "https://www.youtube.com/results?search_query=profit+and+loss+for+bank+exams+playlist" },
  { topic: "Time & Work",         category: "Quant",     link: "https://www.youtube.com/results?search_query=time+and+work+for+bank+exams+playlist" },
  { topic: "Data Interpretation", category: "Quant",     link: "https://www.youtube.com/results?search_query=data+interpretation+for+bank+exams+playlist" },
  { topic: "Number Series",       category: "Quant",     link: "https://www.youtube.com/results?search_query=number+series+for+bank+exams+playlist" },
  
  // Reasoning
  { topic: "Syllogism",          category: "Reasoning", link: "https://www.youtube.com/results?search_query=syllogism+for+bank+exams+playlist" },
  { topic: "Coding-Decoding",    category: "Reasoning", link: "https://www.youtube.com/results?search_query=coding+decoding+for+bank+exams+playlist" },
  { topic: "Blood Relations",    category: "Reasoning", link: "https://www.youtube.com/results?search_query=blood+relations+for+bank+exams+playlist" },
  { topic: "Puzzles",            category: "Reasoning", link: "https://www.youtube.com/results?search_query=puzzles+for+bank+exams+playlist" },
  { topic: "Seating Arrangement",category: "Reasoning", link: "https://www.youtube.com/results?search_query=seating+arrangement+for+bank+exams+playlist" },
  
  // English
  { topic: "Error Detection",     category: "English",   link: "https://www.youtube.com/results?search_query=error+detection+english+for+bank+exams+playlist" },
  { topic: "Reading Comprehension",category: "English",  link: "https://www.youtube.com/results?search_query=reading+comprehension+english+for+bank+exams+playlist" },
  { topic: "Cloze Test",          category: "English",   link: "https://www.youtube.com/results?search_query=cloze+test+english+for+bank+exams+playlist" },
  
  // GA
  { topic: "Banking Awareness",   category: "GA",        link: "https://www.youtube.com/results?search_query=banking+awareness+for+bank+exams+playlist" },
  { topic: "Static GK",           category: "GA",        link: "https://www.youtube.com/results?search_query=static+gk+for+bank+exams+playlist" },
  { topic: "Financial Awareness", category: "GA",        link: "https://www.youtube.com/results?search_query=financial+awareness+for+bank+exams+playlist" }
];

const TRENDING = ["Probability", "Data Interpretation", "Syllogism", "Puzzles", "Banking Awareness", "Number Series"];

export default function VideoResources() {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);

  const handleSearch = (e) => {
    const val = e.target.value;
    setQuery(val);
    if (val.trim().length > 1) {
      const found = TOPIC_MAP.filter(t => t.topic.toLowerCase().includes(val.toLowerCase()));
      setResults(found);
    } else {
      setResults([]);
    }
  };

  const handleQuickClick = (topicName) => {
    setQuery(topicName);
    const found = TOPIC_MAP.filter(t => t.topic === topicName);
    setResults(found);
  };

  return (
    <div style={{ maxWidth: 800, margin: "0 auto", padding: "20px 0" }}>
      <div style={{ textAlign: "center", marginBottom: 40 }}>
        <h1 className="page-title" style={{ fontSize: 28, marginBottom: 12 }}>Video Tutorials</h1>
        <p className="page-sub" style={{ fontSize: 15 }}>What do you want to learn today? Get curated YouTube playlists instantly.</p>
      </div>

      {/* Search Bar Area */}
      <div className="card" style={{ padding: "30px", marginBottom: 30, boxShadow: "var(--shadow-md)" }}>
        <div style={{ position: "relative" }}>
          <input
            type="text"
            className="form-input"
            placeholder="Search any topic (e.g. Probability, Syllogism...)"
            style={{ padding: "16px 20px", fontSize: 16, borderRadius: 12 }}
            value={query}
            onChange={handleSearch}
          />
          <span style={{ position: "absolute", right: 20, top: "50%", transform: "translateY(-50%)", fontSize: 20 }}>🔍</span>
        </div>

        {!query && (
          <div style={{ marginTop: 24 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: ".05em", marginBottom: 12 }}>Trending Topics</div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
              {TRENDING.map(t => (
                <button 
                  key={t} 
                  className="filter-btn" 
                  style={{ borderRadius: 8, padding: "8px 16px" }}
                  onClick={() => handleQuickClick(t)}
                >
                  {t}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Results */}
      {query && (
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          {results.length === 0 ? (
            <div className="card" style={{ textAlign: "center", padding: 40 }}>
              <p style={{ color: "var(--text-muted)" }}>We couldn't find a curated playlist for "<strong>{query}</strong>". Try a broader topic like "Quant" or "Reasoning".</p>
            </div>
          ) : (
            results.map((res, i) => (
              <div key={i} className="card" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: 24, borderLeft: "5px solid var(--blue)" }}>
                <div>
                  <div style={{ fontSize: 12, fontWeight: 700, color: "var(--blue)", textTransform: "uppercase", marginBottom: 4 }}>{res.category}</div>
                  <h3 style={{ fontSize: 18, fontWeight: 800 }}>{res.topic} Masterclass Playlist</h3>
                  <p style={{ fontSize: 13, color: "var(--text-secondary)", marginTop: 4 }}>Full conceptual videos and practice sets curated for IBPS/SBI Exams.</p>
                </div>
                <a 
                  href={res.link} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="btn btn-blue"
                  style={{ borderRadius: 10, padding: "12px 24px" }}
                >
                  Watch Now ↗
                </a>
              </div>
            ))
          )}
        </div>
      )}

      {/* Info Banner */}
      <div style={{ marginTop: 40, padding: 20, background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 12, textAlign: "center" }}>
        <div style={{ fontSize: 18, marginBottom: 8 }}>💡</div>
        <div style={{ fontSize: 14, fontWeight: 700 }}>Expert Recommendation</div>
        <p style={{ fontSize: 13, color: "var(--text-secondary)", marginTop: 5, lineHeight: 1.6 }}>
          For best results, watch the conceptual videos in these playlists before attempting the <strong>Adaptive Practice</strong> sessions for that topic.
        </p>
      </div>
    </div>
  );
}
